import { TranslatedString } from '@frontend/lang';

import { useScreen } from '../../screens/useScreen';
import { WizardNavigationHeaderProps } from './wizard-navigation-header.component';

const useWizardNavigationHeader = (props: WizardNavigationHeaderProps) => {
    const { store, onBack, backEnabled, onHome } = useScreen();

    const title =
        props.title ||
        (store?.functionality ? (
            <TranslatedString
                object={store!.functionality}
                objectKey='name'
            />
        ) : (
            store?.wizard.name || '...'
        ));

    return {
        title: title,
        onBack: props.onBack ? props.onBack : backEnabled ? onBack : undefined,
        onHome
    };
};

export default useWizardNavigationHeader;
